const caseBg = document.querySelectorAll('.ne-hero');

const isDesktopLarge = () => window.matchMedia('(min-width: 1400px)').matches;
const isDesktopMedium = () => window.matchMedia('(min-width: 1200px) and (max-width: 1399px)').matches;
const isTabletLarge = () => window.matchMedia('(min-width: 992px) and (max-width: 1199px)').matches;
const isTabletMedium = () => window.matchMedia('(min-width: 768px) and (max-width: 991px)').matches;
const isTabletSmall = () => window.matchMedia('(min-width: 577px) and (max-width: 767px)').matches;
const isMobile = () => window.matchMedia('(max-width: 576px)').matches;

function updateBackgroundImages() {
    let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    caseBg.forEach(function (container) {
        let desktopLargeImage = container.getAttribute('data-desktop-large-image');
        let desktopMediumImage = container.getAttribute('data-desktop-medium-image');
        let tabletLargeImage = container.getAttribute('data-tablet-large-image');
        let tabletMediumImage = container.getAttribute('data-tablet-medium-image');
        let tabletSmallImage = container.getAttribute('data-tablet-small-image');
        let mobileImage = container.getAttribute('data-mobile-image');

        if (isDesktopLarge()) {
            container.style.backgroundImage = `url(${desktopLargeImage})`;
        } else if (isDesktopMedium()) {
            container.style.backgroundImage = `url(${desktopMediumImage})`;
        } else if (isTabletLarge()) {
            container.style.backgroundImage = `url(${tabletLargeImage})`;
        }else if (isTabletMedium()) {
            container.style.backgroundImage = `url(${tabletMediumImage})`;
        } else if (isTabletSmall()) {
            container.style.backgroundImage = `url(${tabletSmallImage})`;
        } else if (isMobile()) {
            container.style.backgroundImage = `url(${mobileImage})`;
        } else {
            container.style.backgroundImage = 'none';
        }
    });
}

updateBackgroundImages();
window.addEventListener('resize', updateBackgroundImages);